import { doLogout } from 'actions/authAction'
import {
  BASE_URL
} from 'actions/constant'

export const MAPPING_CONTAINER_GET_SUCCESS = "MAPPING_CONTAINER_GET_SUCCESS"
export const MAPPING_LIST_CONTAINER_GET_SUCCESS = "MAPPING_LIST_CONTAINER_GET_SUCCESS"
export const ADD_MAPPING_CONTAINER_GET_SUCCESS = "ADD_MAPPING_CONTAINER_GET_SUCCESS"
export const EDIT_MAPPING_CONTAINER_GET_SUCCESS = "ADD_MAPPING_CONTAINER_GET_SUCCESS"
export const DELETE_MAPPING_CONTAINER_GET_SUCCESS = "DELETE_MAPPING_CONTAINER_GET_SUCCESS"
export const MAPPING_CONTAINER_MODAL_LIST = "MAPPING_CONTAINER_MODAL_LIST"
export const MAPPING_CONTAINER_MODAL = "MAPPING_CONTAINER_MODAL"

const mappingContainerGetSuccess = (bool, container, msg) => {
  return {
    type: MAPPING_CONTAINER_GET_SUCCESS,
    load: bool,
    val: container.data,
    msg:msg
  }
}
const mappingListContainerGetSuccess = (bool, container, msg) => {
  return {
    type: MAPPING_LIST_CONTAINER_GET_SUCCESS,
    load: bool,
    val: container.data,
    msg:msg
  }
}
export const ModalAction = ({show, data})=> async dispatch => {
  dispatch({
      type: MAPPING_CONTAINER_MODAL,
      show: show,
      value:data
  })
}
const addMappingContainerGetSuccess = (bool, success, msg) => {
  return {
    type: ADD_MAPPING_CONTAINER_GET_SUCCESS,
    load: bool,
    val: success,
    msg:msg
  }
}


const editMappingContainerGetSuccess = (bool, success, msg) => {
  return {
    type: EDIT_MAPPING_CONTAINER_GET_SUCCESS,
    load: bool,
    val: success,
    msg:msg
  }
}

export function mappingContainerListAll(data) {
  return (dispatch) => {
      dispatch(mappingListContainerGetSuccess(true, {data: []}, ''))
      let token = localStorage.getItem('tolaut@token') || null
      let config = {}
      if(token) {
          config = {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          }
        } else {
          throw Error("Authentication error")
        }
        fetch(BASE_URL + 'mapping-container/list', config)
        .then((response) => {
          if (response.status === 401) {
            dispatch(doLogout())
          }
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status ===200){
            dispatch(mappingListContainerGetSuccess(false, data, ''))
          }else{
            dispatch(mappingListContainerGetSuccess(false, {data: []}, data.msg))
          }
        })
        .catch((err) => {
          dispatch(mappingListContainerGetSuccess(false, {data: []}, err))
        })
  }
}

export function mappingContainerAll(data) {
  return (dispatch) => {
      dispatch(mappingContainerGetSuccess(true, {data: []}, ''))
      let token = localStorage.getItem('tolaut@token') || null
      let config = {}
      if(token) {
          config = {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          }
        } else {
          throw Error("Authentication error")
        }
        fetch(BASE_URL + 'mapping-container/get-all', config)
        .then((response) => {
          if (response.status === 401) {
            dispatch(doLogout())
          }
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status ===200){
            dispatch(mappingContainerGetSuccess(false, data, ''))
          }else{
            dispatch(mappingContainerGetSuccess(false, {data: []}, data.msg))
          }
        })
        .catch((err) => {
          dispatch(mappingContainerGetSuccess(false, {data: []}, err))
        })
  }
}

export function addMappingContainerAll(data) {
  return (dispatch) => {
      dispatch(addMappingContainerGetSuccess(true, false, ''))
      let token = localStorage.getItem('tolaut@token') || null
      let config = {}
      if(token) {
          config = {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          }
        } else {
          throw Error("Authentication error")
        }
        fetch(BASE_URL + 'mapping-container/', config)
        .then((response) => {
          if (response.status === 401) {
            dispatch(doLogout())
          }
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status ===200){
            dispatch(addMappingContainerGetSuccess(false, true, ''))
          }else{
            window.alert(data.msg)
            dispatch(addMappingContainerGetSuccess(false, false, data.msg))
          }
        })
        .catch((err) => {
          window.alert(err.message || err)
        })
  }
}

export function editMappingContainerAll(data) {
  return (dispatch) => {
      dispatch(editMappingContainerGetSuccess(true, false, ''))
      let token = localStorage.getItem('tolaut@token') || null
      let config = {}
      if(token) {
          config = {
            method: 'PUT',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          }
        } else {
          throw Error("Authentication error")
        }
        fetch(BASE_URL + 'mapping-container/', config)
        .then((response) => {
          if (response.status === 401) {
            dispatch(doLogout())
          }
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status ===200){
            dispatch(editMappingContainerGetSuccess(false, true, ''))
          }else{
            window.alert(data.msg)
            dispatch(editMappingContainerGetSuccess(false, false, data.msg))
          }
        })
        .catch((err) => {
          window.alert(err.message || err)
          dispatch(editMappingContainerGetSuccess(false, false, err))
        })
  }
}
